// extracted by mini-css-extract-plugin
export default {"description":"style_description__fKv7I","fade-in":"style_fade-in__GgJ4B","top":"style_top__sxKS+","image":"style_image__cl5xv"};